import { useQuery } from '@tanstack/react-query';

import { namespaceAccessInspect } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';

export function useNamespaceAccessPolicy(
  environmentId: EnvironmentId,
  namespaceName: string
) {
  return useQuery({
    queryKey: namespaceAccessPolicyQueryKey(environmentId, namespaceName),
    queryFn: () => getNamespaceAccessPolicy(environmentId, namespaceName),
    enabled: !!environmentId && !!namespaceName,
    ...withError('Unable to load namespace access'),
  });
}

export function namespaceAccessPolicyQueryKey(
  environmentId: EnvironmentId,
  namespaceName: string
) {
  return ['environments', environmentId, 'namespaceAccess', namespaceName];
}

async function getNamespaceAccessPolicy(
  environmentId: EnvironmentId,
  namespaceName: string
) {
  const { data } = await namespaceAccessInspect({
    path: { id: environmentId, namespace: namespaceName },
  });

  return data;
}
